import * as actions from "../global/actionTypes";

export const updateLocationState = (location) => ({
  type: actions.UPDATE_CURRENT_LOCATION_STATE,
  location,
});



// WEBPACK FOOTER //
// ./src/actions/map.js